<template>
    <div v-loading="!finishGetList">
        <elastic-filter-link :filterLayout="filterLayout" :sortData="filterSet.sort"
                             :filterData="filterSet.filter" :paginationData="filterSet.page"></elastic-filter-link>
        <elastic-list-link :listLayout="listLayout" :elasticData="List" :paginationData="filterSet.page"
                           ref="elasticListLink"></elastic-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                         :finishGetList="finishGetList" :listLength="List.length"></pagination-link>
    </div>
</template>

<script>
import elasticUtil from "@/components/elastic/elasticUtil";
import ElasticFilterLink from "@/components/elastic/ElasticFilterLink";
import ElasticListLink from "@/components/elastic/ElasticListLink";
import PaginationLink from "@/components/elastic/PaginationLink";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import listMixins from "@/mixins/listMixins";
import filterMixins from "@/mixins/filterMixins";
import util from "@/mixins/util";

const {filterConfig, elasticDefaultBody} = elasticUtil;
import momentTimezone from "moment-timezone";
export default {
    name: "ElasticListComponent",
    mixins: [filterMixins, listMixins, elasticUtil, alertMixins],
    components: {ElasticFilterLink, ElasticListLink, PaginationLink},
    inject: ['changeLoading'],
    provide: function () {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            resetFilter: this.resetFilter,
            elasticListSetData: this.setData,
            setSort: this.setSort,
        }
    },
    props: {
        elasticType: '',
        cafeKey: {default: 0},
    },
    data() {
        return {
            filterLayout: '',
            listLayout: '',
            emptyLayout: '',
            paginationLayout: '',
            elaType: '',
            elaIndex: '',
            page: 0,
            pageRow: 10,
            paginationType: 'firstInitPage',
            listApiParamSet: {},
            sortOptions: {},
            startSort: null,
            checkLive: false,
            getAlarmLive: false,
            checkEnd: false,
            checkCafe: false,

            isFirstGet: true,
        }
    },
    created() {
        this.initConfig();
    },
    mounted() {
        EventBus.$on('elasticListGetList', this.getList)
    },
    beforeDestroy() {
        EventBus.$off('elasticListGetList')
    },
    destroyed() {
    },
    computed: {},

    methods: {

        initConfig() {
            let elasticConfig = this.returnElasticConfig(this.elasticType);
            this.filterLayout = elasticConfig.filterLayout;
            this.listLayout = elasticConfig.listLayout;
            this.emptyLayout = elasticConfig.emptyLayout;
            this.paginationLayout = elasticConfig.paginationLayout;
            this.elaIndex = elasticConfig.elaIndex;
            this.elaType = elasticConfig.elaType;
            this.pageRow = elasticConfig.pageRow;
            this.paginationType = elasticConfig.paginationType;
            this.sortOptions = elasticConfig.sortOptions;
            this.startSort = elasticConfig.startSort;
            this.isGetFirst = elasticConfig.isGetFirst;
            this.checkLive = elasticConfig.checkLive;
            this.getAlarmLive = elasticConfig.getAlarmLive;
            this.checkEnd = elasticConfig.checkEnd;
            this.checkCafe = elasticConfig.checkCafe;

            if (!util.isEmpty(elasticConfig.listApiParamSet)) {
                this.listApiParamSet = JSON.parse(JSON.stringify(elasticConfig.listApiParamSet));
            }
            if (!util.isEmpty(elasticConfig.isFirstGet)) {
                this.isFirstGet = elasticConfig.isFirstGet;
            }

            if(!util.isEmpty(elasticConfig.listApiParamSet)) {
                this.listApiParamSet = JSON.parse(JSON.stringify(elasticConfig.listApiParamSet));
            }
            this.settingSortOptions();

            let listOptions = {
                index: this.elaIndex,
                type: this.elaType,
            };

            if (this.checkLive === true) {
                this.setLiveQuery();
            }

            if (!util.isEmpty(this.memberKey) && this.memberKey !== 0) {
                this.setMemberQuery()
            }
            if (!util.isEmpty(this.cafeKey) && this.cafeKey !== 0) {
                this.setCafeQuery()
            }
            if (!util.isEmpty(this.listApiParamSet)) {
                listOptions.defaultBody = this.listApiParamSet;
            }

            if (this.checkEnd === true) {
                this.setEndLiveQuery();
            }


            this.setDefaultPageSize();
            this.initList('elastic', listOptions);
            this.setFilterConfig(filterConfig);
            this.setParserType('url', this.$route.fullPath);
            if (this.isFirstGet) {
                this.getList(true);
            }
        },

        setData(key, value) {
            this[key] = value;
        },
        setDefaultPageSize() {
            if (this.pageRow != this.filterSet.page.size) {
                this.filterSet.page.size = this.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }
        },
        settingSortOptions() {
            if (!util.isEmpty(this.sortOptions) && util.isObject(this.sortOptions)) {

                let inputSortOptions = JSON.parse(JSON.stringify(this.sortOptions));

                this.sortOptions = inputSortOptions;
                this.setSortOptions(inputSortOptions, this.startSort);

            }
        },
        setDefaultBody() {
            if (util.isEmpty(this.listApiParamSet)) {
                this.listApiParamSet = JSON.parse(JSON.stringify(elasticDefaultBody));
            }
        },
        setLiveQuery() {
            let timestamp = momentTimezone().tz('Asia/Seoul').add(-10, 'months').format('X');
            this.setDefaultBody();
            let appendBody = {
                bool: {
                    should: [
                        {
                            bool: {
                                filter: [
                                    {match: {'bj_live': 0}},
                                    {range: {'bj_starttime': {gt: timestamp}}},
                                ]
                            }
                        },
                        {
                            match: {'bj_live': 1},
                        }
                    ]
                }
            };
            this.listApiParamSet.query.bool.must.push(appendBody);
        },
        setEndLiveQuery() {
            let timestamp = momentTimezone().tz('Asia/Seoul').add({days: -3, hours: -5}).format('X');
            this.setDefaultBody();
            let appendBody = {
                bool: {
                    should: [
                        {
                            bool: {
                                filter: [
                                    {match: {'bj_live': 2}},
                                    {range: {'bj_starttime': {gt: timestamp}}},
                                ]
                            }
                        }
                    ]
                }
            };
            this.listApiParamSet.query.bool.must.push(appendBody);
        },


        setMemberQuery() {
            this.setDefaultBody();
            let appendBody = {
                match: {'mb_no': this.memberKey}
            }
            this.listApiParamSet.query.bool.must.push(appendBody);
        },
        setCafeQuery() {
            this.setDefaultBody();
            let appendBody = {
                match: {'Cafe.Data.c_idx': this.cafeKey}
            }
            this.listApiParamSet.query.bool.must.push(appendBody);
        },
    },

    watch: {},
}
</script>

<style scoped>

</style>
